export class CustomizationInputPropertiesImage {

  static getArrExtensions(customizationInputProperties : CustomizationInputPropertiesImage) {
    return customizationInputProperties.extensions;
  }
  static getMaxWidth(customizationInputProperties : CustomizationInputPropertiesImage) {
    return customizationInputProperties.maxWidthPx;
  }
  static getMaxHeigth(customizationInputProperties : CustomizationInputPropertiesImage) {
    return customizationInputProperties.maxHeightPx;
  }

  private extensions : string[] = [];
  private maxWidthPx : number = 0;
  private maxHeightPx : number = 0;
}
